import { Component, computed, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { TfsIconDirective } from '@tfs/material/tfs-icon';

import { DATA_SYNC_SOURCES, DataSyncJob } from '../data-sync-source';

@Component({
  selector: 'tfs-data-sync-panel',
  imports: [MatButtonModule, MatIconModule, MatProgressBarModule, TfsIconDirective],
  templateUrl: './data-sync-panel.component.html',
  styleUrl: './data-sync-panel.component.scss',
})
export class DataSyncPanelComponent {
  private readonly dataSyncSources = inject(DATA_SYNC_SOURCES);
  readonly activeJobs = input<DataSyncJob[]>([]);
  readonly completedJobs = input<DataSyncJob[]>([]);

  protected readonly clearAllDisabled = computed(() => this.completedJobs().length === 0);

  protected dismiss(job: DataSyncJob): void {
    this.dataSyncSources.find(source => source.id === job.sourceId)?.dismiss(job.id);
  }

  protected clearAll(): void {
    for (const completedJob of this.completedJobs()) this.dismiss(completedJob);
  }
}
